// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField';

class DialogEditUrl extends React.PureComponent {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        close: PropTypes.func,
        open: PropTypes.bool,
        url: PropTypes.string,
        changeAction: PropTypes.func,
        fullScreen: PropTypes.bool,
    };

    handleChangeUrl = event => {
        this.setState({ url: event.target.value });
    };

    componentDidMount() {
        this.input = React.createRef();
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            const newUrl = this.state ? this.state.url : this.props.url;
            this.props.changeAction({ url: newUrl });
            this.props.close();
        }
    };

    render() {
        const { fullScreen, classes, url, open, close, changeAction } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                classes={{
                    paper: classes.dialogPaperRoot
                }}
                aria-labelledby='responsive-dialog-title'
            >
                <DialogTitle id='responsive-dialog-title'>{translate.i18n('EDIT_URL')}</DialogTitle>
                <DialogContent>
                    <TextField
                        id='url'
                        defaultValue={url}
                        label={translate.i18n('URL')}
                        onChange={this.handleChangeUrl}
                        ref={this.input}
                        classes={{
                            root: classes.urlTextField
                        }}
                        onKeyPress={this.handleKeyPress}
                    />
                </DialogContent>
                <DialogActions>
                    <IconButton color='primary' onClick={() => {
                        const newUrl = this.state ? this.state.url : url;
                        changeAction({ url: newUrl });
                        close();
                    }}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    dialogPaperRoot: {
        width: '100%',
        maxWidth: '700px'
    },
    urlTextField: {
        width: '100%'
    }
});

export default withStyles(styles)(DialogEditUrl);
